export const LOAD_FREQUENCY_ENUM = 'LOAD_FREQUENCY_ENUM'
export const LOAD_CONTEXT_ENUM = 'LOAD_CONTEXT_ENUM'
export const LOAD_TEMPLATES = 'LOAD_TEMPLATES'
export const LOAD_SUITS_APPS = 'LOAD_SUITS_APPS'